<template>
    <div>
        <GChart
            type="PieChart"
            :settings="{packages: ['corechart'], language: 'pt-br'}"
            :data="chartDataFinal"
            :options="chartOptions"
        />
    </div>
</template>

<script>
export default {
    props: ['chartData', 'currency'],
    data() {
        return {
            chartOptions: {
                fontName: 'Muli',
                height: 300,
                chartArea: {
                    width: '100%',
                    height: 280
                },
                is3D: true,
            }
        }
    },
    computed: {
        chartDataFinal() {
            return this.chartData
        }
    },
    created() {
        this.chartDataFinal.unshift(["", ""])
    }
}
</script>

<style scoped>

</style>
